
























/* eslint-disable camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Notification_NewsCommentReactionViewObject } from '@/types/apiServerContract';
import { Emoji } from '@/core/constants';
import { NewsModule } from '@/store/modules/news/news.store';
import NewsFetchService from '@/services/news/newsFetch.service';

@Component
export default class NotificationTypeNewsCommentReaction extends Vue {
	@Prop({ required: true, type: Object }) notification!: Notification_NewsCommentReactionViewObject;
	@Prop({ required: true, type: String }) reactionIcon!: Emoji;

	async getNewsData(id: number) {
	    const news = NewsModule.news.find(x => x.id === id);
	    if (news) return Promise.resolve(news);
	    return await NewsFetchService.requestData(id);
	}
}
